import React from 'react';

import { FluxoProvider } from './fluxos';
import { OpenFinanceProvider } from './openFinance';
import { ReceitaDespesaProvider } from './receitasDespesas';

function FinanceiroProvider({ children }) {
  return <FluxoProvider>
    <ReceitaDespesaProvider>
      <OpenFinanceProvider>{children}</OpenFinanceProvider>
    </ReceitaDespesaProvider>
  </FluxoProvider>
}

export default FinanceiroProvider;
